<template>
  <div>
    <h1>404 : Page Not Found!</h1>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
  scroll-behavior: smooth;
  font-family: "Urbanist", sans-serif;
}
h1 {
  font-size: 2.4rem;
  font-weight: 800;
  text-align: center;
}
</style>
